import styled from 'react-emotion';

const Clear = styled('div')`
  height: ${({ height }) => height ? height + 'px' : 'auto'};
  margin-bottom: ${({ bottom }) => bottom || 0}px;
  margin-top: ${({ top }) => top || 0}px;
  clear: both;
  ::before {
    content: ' ';
    display: table;
  }
  ::after {
    content: ' ';
    display: table;
    clear: both;
  }
`;

export default Clear;



// WEBPACK FOOTER //
// ./src/components/ui/Clear.jsx